import { LockedByIRTooltip } from "../components/tooltips/lockedByIR"
import { LockedByProviderTooltip } from "../components/tooltips/lockedByProvider"
import { LockedByTickerTooltip } from "../components/tooltips/lockedByTicker"
import type { UseAssetFormState } from "../types"

export const lockedByIr = (state: UseAssetFormState) => ({
  lockedReasonBubbletip: {
    variant: 'white',
    placement: 'input-field',
    noPadding: true,
    body: () => <LockedByIRTooltip asset={state.asset} investment={state} />
  }
})

export const lockedByTicker = (_state: UseAssetFormState) => ({
  lockedReasonBubbletip: {
    variant: 'white',
    placement: 'input-field',
    noPadding: true,
    body: () => <LockedByTickerTooltip />
  }
})

export const lockedByProvider = (state: UseAssetFormState) => ({
  lockedReasonBubbletip: {
    variant: 'white',
    placement: 'input-field',
    noPadding: true,
    body: () =>
      state.providerImport ? (
        <LockedByProviderTooltip
          investment={state}
          providerImport={state.providerImport as unknown as any}
        />
      ) : (
        <div></div>
      )
  }
})
